import React, { Component } from 'react'; // eslint-disable-line
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Tooltip from 'rc-tooltip';
import i18n from '../../i18n';
import SortablePageSections from './SortablePageSections';
import AddPlus from '../svg/AddPlus';
import LargeModal from '../../containers/modals/LargeModal';
import constants from '../../constants';
import _actions from '../../actions';
import CustomContentTypeSelector from './CustomContentTypeSelector';
import TextContentEditor from './TextContentEditor';
import TextWithImageContentEditor from './TextWithImageContentEditor';
import VideoContentEditor from './VideoContentEditor';
import LinkButtonContentEditor from './LinkButtonContentEditor';
import BannerContentEditor from './BannerContentEditor';

class SortablePageSectionsList extends Component {
    constructor(props) {
        super(props);
        this.deleteContentSection = this.deleteContentSection.bind(this);
        this.editContentBlock = this.editContentBlock.bind(this);
        this.addContentBlock = this.addContentBlock.bind(this);
        this.addDivider = this.addDivider.bind(this);
        this.changeFontSize = this.changeFontSize.bind(this);
        this.updateTapTypeFromEvent = this.updateTapTypeFromEvent.bind(this);
        this.handleColorChange = this.handleColorChange.bind(this);
        this.addContentType = this.addContentType.bind(this);
        this.saveNewContent = this.saveNewContent.bind(this);
        this.deleteContentBlock = this.deleteContentBlock.bind(this);
        this.setStateFromEvent = this.setStateFromEvent.bind(this);
        this.handleChangeAlignment = this.handleChangeAlignment.bind(this);
        this.state = {
            loaded: false,
            sections: this.props.sections,
            showContentModal: false,
            contentModalTitle: '',
            contentModalContent: {},
            contentModalAdd: true,
        };
    }

    componentDidUpdate(prevState, prevProps) {
        if (!this.props.changing && this.props.changing !== prevProps.changing) {
            // eslint-disable-next-line react/no-did-update-set-state
            if (!this.state.loaded) {
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    loaded: true,
                    sections: this.props.sections,
                });
            }
        }
    }

    // eslint-disable-next-line react/sort-comp
    addContentBlock(sectionId) {
        this.setState({
            showContentModal: true, contentModalTitle: i18n.t('content.add-content'), contentModalContent: { contentSectionId: sectionId }, contentModalAdd: true,
        });
        this.props.handleShowPreview(false);
    }

    editContentBlock(content) {
        this.setState({
            showContentModal: true, contentModalTitle: i18n.t('content.edit-content'), contentModalContent: content, contentModalAdd: false,
        });
        this.props.handleShowPreview(false);
    }

    deleteContentBlock(id) {
        this.setState({ loaded: false });
        this.props.deleteContentBlock(id);
    }

    deleteContentSection(id) {
        this.setState({ loaded: false });
        this.props.deleteContentSection(id);
    }

    addContentSection() {
        this.setState({ loaded: false });
        this.props.addContentSection();
    }

    addDivider(precedingId, sectionId) {
        this.setState({ loaded: false });
        this.props.addDivider(precedingId, sectionId);
    }

    saveNewContent() {
        if (this.props.crop.croppedImage?.imagePath && (this.state.contentModalContent.contentType === 107 || this.state.contentModalContent.contentType === 105)) {
            const imageContent = this.state.contentModalContent;
            imageContent.imageId = this.props.crop.croppedImage.id;
            if (this.state.contentModalContent.tapType === 2 && this.state.contentModalContent.tapDestination === '5') {
                imageContent.tapType = 5;
                imageContent.tapDestination = null;
            }
            if (this.state.contentModalAdd) {
                this.props.addContent(imageContent);
            } else {
                this.props.updateContent(imageContent);
            }
        } else if (this.state.contentModalContent.tapType === 2 && this.state.contentModalContent.tapDestination === '5') {
            const send = this.state.contentModalContent;
            send.tapType = 5;
            send.tapDestination = null;
            if (this.state.contentModalAdd) {
                this.props.addContent(send);
            } else {
                this.props.updateContent(send);
            }
        } else if (this.state.contentModalAdd) {
            this.props.addContent(this.state.contentModalContent);
        } else {
            this.props.updateContent(this.state.contentModalContent);
        }
        this.setState({
            loaded: false, showContentModal: false, contentModalTitle: '', contentModalContent: {},
        });
        this.props.handleShowPreview(true);
    }

    changeFontSize(size) {
        this.setState((prevState) => { return { contentModalContent: { ...prevState.contentModalContent, headerSize: size } }; });
    }

    handleColorChange(color, field) {
        // eslint-disable-next-line no-param-reassign
        this.setState((prevState) => { prevState.contentModalContent[field] = color; return { contentModalContent: { ...prevState.contentModalContent } }; });
    }

    handleChangeAlignment(alignment) {
        this.setState((prevState) => { return { contentModalContent: { ...prevState.contentModalContent, contentAlign: alignment } }; });
    }

    updateTapTypeFromEvent(e) {
        if (this.state.contentModalContent.tapType !== e) {
            this.setState((prevState) => {
                return {
                    contentModalContent: {
                        ...prevState.contentModalContent,
                        tapType: e,
                        tapDestination: '',
                    },
                };
            });
        }
    }

    setStateFromEvent(e, stateKey) {
        if (typeof e === 'undefined' || e === null) {
            return;
        }
        // forms/pages dropdowns returns the data object, not the control
        if (stateKey === 'tapDestination' && !e.target) {
            // eslint-disable-next-line no-param-reassign
            this.setState((prevState) => { prevState.contentModalContent[stateKey] = e.value; return { contentModalContent: { ...prevState.contentModalContent } }; });
        } else if (stateKey === 'cropStyle') {
            // eslint-disable-next-line no-param-reassign
            this.setState((prevState) => { prevState.contentModalContent[stateKey] = parseInt(e.target.value, 10); return { contentModalContent: { ...prevState.contentModalContent } }; });
        } else if (stateKey === 'isFullWidth') {
            // eslint-disable-next-line no-param-reassign
            this.setState((prevState) => { prevState.contentModalContent[stateKey] = e.target.checked; return { contentModalContent: { ...prevState.contentModalContent } }; });
        } else if (stateKey === 'appearanceType' || stateKey === 'videoType' || stateKey === 'imageId' || stateKey === 'imageUrl') {
            // eslint-disable-next-line no-param-reassign
            this.setState((prevState) => { prevState.contentModalContent[stateKey] = e; return { contentModalContent: { ...prevState.contentModalContent } }; });
        } else {
            // eslint-disable-next-line no-param-reassign
            this.setState((prevState) => { prevState.contentModalContent[stateKey] = e.target.value; return { contentModalContent: { ...prevState.contentModalContent } }; });
        }
    }

    addContentType(type) {
        if (this.state.contentModalAdd) {
            this.setState((prevState) => {
                switch (type) {
                    case 103:
                        return {
                            contentModalContent: {
                                contentType: 103,
                                videoUrl: '',
                                isFullWidth: false,
                                contentSectionId: prevState.contentModalContent.contentSectionId,
                                isUrlValid: false,
                                videoType: 3,
                            },
                        };
                    case 104:
                        return {
                            contentModalContent: {
                                contentType: 104,
                                headerSize: 1,
                                headerText: '',
                                headerTextColor: 3,
                                subheaderText: '',
                                subheaderTextColor: 4,
                                text: '',
                                textColor: 3,
                                tapType: 1,
                                contentSectionId: prevState.contentModalContent.contentSectionId,
                            },
                        };
                    case 105:
                        return {
                            contentModalContent: {
                                contentType: 105,
                                imageId: '',
                                imageUrl: '',
                                cropStyle: 1,
                                headerText: '',
                                headerTextColor: 3,
                                subheaderText: '',
                                subheaderTextColor: 4,
                                text: '',
                                textColor: 3,
                                tapType: 1,
                                contentSectionId: prevState.contentModalContent.contentSectionId,
                            },
                        };
                    case 106:
                        return {
                            contentModalContent: {
                                contentType: 106,
                                contentSectionId: prevState.contentModalContent.contentSectionId,
                                tapType: 2,
                                text: '',
                                appearanceType: 1,
                                contentAlign: 2,
                            },
                        };
                    case 107:
                        return {
                            contentModalContent: {
                                contentType: 107,
                                contentSectionId: prevState.contentModalContent.contentSectionId,
                                bannerText: '',
                                tapType: 1,
                                imageId: '',
                                bannerOverlayColor: 1,
                                imageUrl: '',
                                bannerTextColor: '#ffffff',
                            },
                        };
                    default:
                        // eslint-disable-next-line prefer-template
                        return {
                            contentModalContent: {
                                contentSectionId: prevState.contentModalContent.contentSectionId,
                            },
                        };
                }
            });
        }
    }

    isValid() {
        if (this.state.contentModalContent?.contentType) {
            if (this.state.contentModalContent.contentType !== 103) {
                if (this.state.contentModalContent.tapType !== 1 && !(this.state.contentModalContent.tapDestination?.length > 0)) {
                    return {
                        valid: false,
                        message: 'content.validation.tap-destination-required',
                    };
                }
                if (this.state.contentModalContent.tapType === 4 && !(this.state.contentModalContent.tapDestination?.indexOf('.') > 0 && this.state.contentModalContent.tapDestination?.indexOf('.') < this.state.contentModalContent.tapDestination?.length - 2)) {
                    return {
                        valid: false,
                        message: 'content.validation.tap-destination-required',
                    };
                }
            }
            switch (this.state.contentModalContent.contentType) {
                case 103:
                    if (this.state.contentModalContent.videoUrl.length === 0) {
                        return {
                            valid: false,
                            message: 'content.validation.video-url-required',
                        };
                    }
                    return {
                        valid: this.state.contentModalContent.isUrlValid,
                        message: 'content.validation.video-url-invalid',
                    };
                case 104:
                    return {
                        valid: this.state.contentModalContent.text.length > 0
                            || this.state.contentModalContent.subheaderText.length > 0
                            || this.state.contentModalContent.headerText.length > 0,
                        message: 'content.validation.text-title-required',
                    };
                case 105:
                    if (this.props.crop.inProgress !== false) {
                        return {
                            valid: false,
                            message: 'content.validation.crop-in-progress',
                        };
                    }
                    if (this.state.contentModalContent.imageId.length === 0 && typeof this.props.crop.croppedImage?.imagePath === 'undefined') {
                        return {
                            valid: false,
                            message: 'content.validation.image-id-required',
                        };
                    }
                    return {
                        valid: this.state.contentModalContent.text.length > 0
                            || this.state.contentModalContent.subheaderText.length > 0
                            || this.state.contentModalContent.headerText.length > 0,
                        message: 'content.validation.text-title-required',
                    };

                case 106:
                    return {
                        valid: this.state.contentModalContent.text.length > 0,
                        message: 'content.validation.text-required',
                    };

                case 107:
                    if (this.props.crop.inProgress !== false) {
                        return {
                            valid: false,
                            message: 'content.validation.crop-in-progress',
                        };
                    }
                    return {
                        valid: this.state.contentModalContent.imageId.length !== 0 || this.props.crop.croppedImage?.imagePath,
                        message: 'content.validation.image-id-required',
                    };
                default:
                    return {
                        valid: false,
                        message: 'content.validation.type-not-set',
                    };
            }
        }

        return {
            valid: false,
            message: 'content.validation.type-not-set',
        };
    }

    render() {
        const { sections } = this.props || [];
        if (sections && sections.length > 0) {
            sections.sort((a, b) => {
                return a.displayOrder - b.displayOrder;
            });
        }
        const formDataValid = this.isValid();
        // eslint-disable-next-line no-nested-ternary
        const saveButton = formDataValid.valid
            ? (this.props.flags.results.customContentPageCount + 1 <= this.props.pages.data.length && this.state.contentModalContent?.tapDestination === '5'
                ? (
                    <button id="content-save" className="btn-design-system primary" type="button" onClick={this.props.upsell}>
                        { this.state.contentModalAdd ? i18n.t('add') : i18n.t('save')}
                    </button>
                )
                : (
                    <button id="content-save" className="btn-design-system primary" type="button" onClick={this.saveNewContent}>
                        { this.state.contentModalAdd ? i18n.t('add') : i18n.t('save')}
                    </button>
                )
            )
            : (
                <Tooltip
                    placement="bottom"
                    trigger="[hover, focus]"
                    mouseEnterDelay={0}
                    mouseLeaveDelay={0.1}
                    overlay={<span data-qa="content-save-validation-message">{i18n.t(formDataValid.message)}</span>}
                >
                    <span style={{ cursor: 'not-allowed' }}>
                        <button id="content-save" className="btn-design-system primary disabled" type="button" onClick={this.saveNewContent}>
                            {this.state.contentModalAdd ? i18n.t('add') : i18n.t('save')}
                        </button>
                    </span>
                </Tooltip>
            );

        return (
            <div>
                <SortablePageSections
                    sections={this.state.sections}
                    canReorderSubItems={this.props.canReorderSubItems}
                    onItemsDisplayOrderChange={this.props.onItemsDisplayOrderChange}
                    onSingleItemChange={this.props.onSingleItemChange}
                    deleteContentSection={this.deleteContentSection}
                    changing={!this.state.loaded}
                    addContentBlock={this.addContentBlock}
                    editContentBlock={this.editContentBlock}
                    deleteContentBlock={this.deleteContentBlock}
                    addDivider={this.addDivider}
                    forms={this.props.forms}
                    pages={this.props.pages}
                />
                <button className="add-content-button" data-qa="add-content-button" type="button" onClick={() => { this.addContentSection(); }}>
                    <AddPlus />
                    {' '}
                    {i18n.t('content.add-content-section')}
                </button>
                {this.state.contentModalContent && ''}
                <LargeModal alertView="pages-modal" title={this.state.contentModalTitle} visible={this.state.showContentModal} close={() => { this.setState({ showContentModal: false, contentModalTitle: '', contentModalContent: {} }); this.props.handleShowPreview(true); }}>
                    <div className="large-modal-scroll-wrapper">
                        <div className="pages-modal-wrap">
                            <div className="content-types">
                                <CustomContentTypeSelector add={this.state.contentModalAdd} active={this.state.contentModalContent?.contentType} addContentType={this.addContentType} />
                                <div className="content-save-cancel">
                                    {saveButton}
                                    <button id="content-cancel" className="btn-design-system secondary" type="button" onClick={() => { this.props.actions.resetImageData(); this.setState({ showContentModal: false, contentModalTitle: '', contentModalContent: {} }); this.props.handleShowPreview(true); }}>{i18n.t('cancel')}</button>
                                </div>
                            </div>
                            <div className="edit-content-section-block">
                                {constants.ContentType.find((c) => {
                                    return c.Id === this.state.contentModalContent.contentType;
                                })?.Name === 'Text'
                                    && (
                                        <TextContentEditor contentModalContent={this.state.contentModalContent} formsItems={this.props.formsItems} formsObjects={this.props.formsObjects} pagesItems={this.props.pagesItems} setStateFromEvent={this.setStateFromEvent} handleColorChange={this.handleColorChange} updateTapTypeFromEvent={this.updateTapTypeFromEvent} changeFontSize={this.changeFontSize} />
                                    )}
                                {constants.ContentType.find((c) => {
                                    return c.Id === this.state.contentModalContent.contentType;
                                })?.Name === 'Image & Text'
                                    && (
                                        <TextWithImageContentEditor contentModalContent={this.state.contentModalContent} formsItems={this.props.formsItems} formsObjects={this.props.formsObjects} pagesItems={this.props.pagesItems} setStateFromEvent={this.setStateFromEvent} handleColorChange={this.handleColorChange} updateTapTypeFromEvent={this.updateTapTypeFromEvent} />
                                    )}

                                {constants.ContentType.find((c) => {
                                    return c.Id === this.state.contentModalContent.contentType;
                                })?.Name === 'LinkButton'
                                    && (
                                        <LinkButtonContentEditor contentModalContent={this.state.contentModalContent} formsItems={this.props.formsItems} formsObjects={this.props.formsObjects} pagesItems={this.props.pagesItems} setStateFromEvent={this.setStateFromEvent} updateTapTypeFromEvent={this.updateTapTypeFromEvent} changeAlignment={this.handleChangeAlignment} />
                                    )}

                                {constants.ContentType.find((c) => {
                                    return c.Id === this.state.contentModalContent.contentType;
                                })?.Name === 'Banner'
                                    && (
                                        <div className="edit-banner-content">
                                            <BannerContentEditor setModalAlert={this.setModalAlert} contentModalContent={this.state.contentModalContent} pagesItems={this.props.pagesItems} formsItems={this.props.formsItems} formsObjects={this.props.formsObjects} setStateFromEvent={this.setStateFromEvent} updateTapTypeFromEvent={this.updateTapTypeFromEvent} />
                                        </div>
                                    )}

                                {constants.ContentType.find((c) => {
                                    return c.Id === this.state.contentModalContent.contentType;
                                })?.Name === 'Video'
                                    && (
                                        <VideoContentEditor contentModalContent={this.state.contentModalContent} setStateFromEvent={this.setStateFromEvent} />
                                    )}
                            </div>
                        </div>
                    </div>
                </LargeModal>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...state,
        ...ownProps,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(_actions, dispatch),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(SortablePageSectionsList);
